export const buildChoiceID = (itemValue) => `modal-choice-${itemValue}`;

export const scrollIntoChoice = (value) => {
  if (value) {
    const id = buildChoiceID(value);
    document.getElementById(id)?.scrollIntoView({ block: "end" });
  }
};
